import React, { ReactElement, useEffect, useState } from 'react';
import { getLabelsByLanguage } from '../../../utilites/util';
import Modal from 'react-bootstrap/Modal';
import SendToTnAccountContainer from '../../../auth/SendToTnAccount';
import './scss/index.scss';

interface Props {
  primaryLabel: string,
  secondaryLabel?:string
}


const RedirectToYettelAccountPopup: React.FC<Props> = (props: Props): ReactElement => {
  const labels =  getLabelsByLanguage();
  const [show] = useState(true);
  const [shouldTriggerRedirect, setShouldTriggerRedirect] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => redirectToYettelAccount(), 3000);
    return () => clearTimeout(timer);
  }, []);

  const redirectToYettelAccount = (): void => {
    setShouldTriggerRedirect(true);
  };

  return (
    <React.Fragment>
      <Modal className='popup wish-list-popup' size='sm' centered show={show}>
        <Modal.Body className="wish-list-popup-body">
          <div className='text-center yettel-font py-3 px-3'>
            <div className='text-start ps-3'>
              {props.primaryLabel}
            </div>
            <div className='text-start pt-4 ps-3'>
              {props.secondaryLabel}
            </div>
            <div className='text-center mt-4 py-2 px-5'>
              <div onClick={() => redirectToYettelAccount()} className="button btn-blue-yettel mt-2">
                {labels.ok}
                <SendToTnAccountContainer from={window.location.href} isTextVisible={false} triggerRedirect={shouldTriggerRedirect} hasIcon={false}/>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default RedirectToYettelAccountPopup;
